export function mergeRolesToSingleRole(roles) {
  const permissionsMap = new Map();

  roles.forEach((role) => {
    if (!role?.permissions) return;
    role.permissions.forEach((permission) => {
      if (!permissionsMap.has(permission.id)) {
        permissionsMap.set(permission.id, {
          ...permission,
          read: permission.read || false,
          write: permission.write || false,
          showInMenu: permission.showInMenu || false
        });
      } else {
        const existingPermission = permissionsMap.get(permission.id);
        permissionsMap.set(permission.id, {
          ...existingPermission,
          read: existingPermission.read || permission.read,
          write: existingPermission.write || permission.write,
          showInMenu: existingPermission.showInMenu || permission.showInMenu
        });
      }
    });
  });

  return {
    id: 'compare-permission-role',
    name: 'compare permission',
    deleted: false,
    editable: true,
    removeable: true,
    resetable: true,
    permissions: Array.from(permissionsMap.values())
  };
}
